module.exports = __webpack_public_path__ + "static/media/U1-T1-11b.0b7101fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T1-11b.svg
// module id = 580
// module chunks = 0